import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import theme from 'theme/theme';

const copy = {
  description: [
    '<p>With those businesses, half a million New Yorkers already lost their livelihood.</p><p>Another 80,000 businesses face the same fate, leaving as many as 1 million households struggling to feed their families and pay rent.</p><p><u>*NYT on 8.3.2020</u></p><img src="/images/the-big-idea/DSC02204-Edit-2.jpg" alt="deli"/><p>As a result, New York living isn\'t the same right now. With every bodega closure, our great city is dying.</p><p><strong>Abandoned by some.</strong></p><p><strong>Avoided by others.</strong></p>',
    '<p>We\'ve built a campaign you should care about because it saves YOUR laundromat.</p><p>YOUR bagel spot, the one that serves your favorite flavor.</p><p>YOUR coffee shop that always gets your order right.</p><p>YOUR dive bar that you frequent for happy hour after work.</p><img src="/images/the-big-idea/DSC00649-Edit-2.jpg" alt="deli"/><p>As a New Yorker, you take pride in what\'s yours. Now is YOUR chance to really show it.</p><p><strong>Your donation could SAVE YOUR CITY.</strong></p>',
  ],
  title: 'OVER 2,800 NEW YORK SMALL BUSINESS OWNERS CLOSED DOORS FOREVER.*',
  imgAlt: 'Boarded Shop',
  imgSrc: '/images/the-big-idea/DSC00968-Edit-2.jpg',
};

const useStyles = makeStyles(() => ({
  container: {
    padding: '90px 0 25px',
    backgroundColor: theme.palette.blue,
  },
  imageContainer: {
    backgroundColor: theme.palette.blue,
    height: '50vh',
    maxHeight: 700,
    overflow: 'hidden',
    position: 'relative',
    width: '100%',

    background: `url(${copy.imgSrc}) no-repeat center center scroll`,
    backgroundSize: 'cover',
  },
  textGroup: {
    marginBottom: '30px',
  },
  titleText: {
    marginBottom: '20px',
  },
  aboutTitle: {
    lineHeight: '.8',
    margin: '6rem 0 7rem',
  },
  description: {
    display: 'block',
    marginBottom: '5em',

    '& img': {
      border: '2px solid #000000',
      margin: '50px 0',
      width: '100%',
    },
  },
}));

const TheBigIdea = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        container
        className={classes.container}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={10} md={8} justify="center">
          <Grid item xs={12} className={classes.textGroup}>
            <Typography variant="h1" className={classes.titleText}>
              The Big Idea
            </Typography>
            <Typography
              variant="h1"
              className={clsx(classes.titleText, classes.aboutTitle)}
              dangerouslySetInnerHTML={{ __html: copy.title }}
            />
            <Typography
              variant="p"
              justify="center"
              className={classes.description}
              dangerouslySetInnerHTML={{ __html: copy.description[0] }}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} className={classes.imageContainer} />

      <Grid
        container
        className={classes.container}
        direction="row"
        justify="center"
        alignItems="center"
      >
        {/* <StoriesNav prev={prev} next={next} /> */}

        <Grid item xs={10} md={8} justify="center">
          <Grid item xs={12} className={classes.textGroup}>
            <Typography
              variant="p"
              justify="center"
              className={classes.description}
              dangerouslySetInnerHTML={{ __html: copy.description[1] }}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

async function getProps() {
  return {
    props: {
      styles: {
        color: theme.palette.blue,
      },
    },
  };
}
export const getServerSideProps = getProps;

export default TheBigIdea;
